import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const documentTypeServices = {
  getDocumentTypeData,
  addNewDocumentType,
  updateDocumentTypeData,
  softDeleteRestoreDocumentType,
  deleteDocumentTypeData,
};

async function addNewDocumentType(userData) {
  const response = await fetch(
    `${config.API_URL}addNewDocumentType`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function updateDocumentTypeData(userData) {
  const response = await fetch(
    `${config.API_URL}updateDocumentType`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function softDeleteRestoreDocumentType(userData) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreDocumentType`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function deleteDocumentTypeData(userData) {
  const response = await fetch(
    `${config.API_URL}deleteDocumentTypeData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function getDocumentTypeData(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL}getDocumentTypeData/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL}getDocumentTypeData/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}